import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../../constants/ActionNameConstants';
import { VENDOR_EDIT_PROFILE_DETAILS_API_URL } from '../../../../../../constants/ApiUrlConstants';
import { WEB_URL } from '../../../../../../constants/Config';
import { DASHBOARD_ROUTE } from '../../../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../../../features/axiosClient';
import history from '../../../../../../features/history';
import { profileEditFailure, profileEditSuccess } from '../actions';

const editProfileAPI = async (formData) => {
  const userData = Cookies.get('userDataProofreader');
  const token = userData ? JSON.parse(userData).Token : null;
  try {
    const data = await postApiRequest(VENDOR_EDIT_PROFILE_DETAILS_API_URL, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

function forwardTo(location) {
  history.push(location);
}

function* handleEditProfileAPI(action) {
  try {
    const response = yield call(editProfileAPI, action.payload);
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
      const userData = Cookies.get('userDataProofreader');
      const token = userData ? JSON.parse(userData).Token : null;
      const userType = userData ? JSON.parse(userData).UserType : null;
      const proofreaderType = userData ? JSON.parse(userData).ProofreaderType : null;
      const userObjectJson = {
        UserInfo: {
          ...JSON.parse(response?.data?.value),
        },
        Token: token,
        UserType: userType,
        ProofreaderType: proofreaderType,
      };
      Cookies.remove('userDataProofreader');
      Cookies.remove('sessionExpireModalOpenProofreader');
      Cookies.set('userDataProofreader', JSON.stringify(userObjectJson), {
        expires: 240 / 1440,
        secure: true,
      });
    }
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    if (response?.data?.success) {
      yield call(forwardTo, DASHBOARD_ROUTE);
    }
    yield put(profileEditSuccess(response));
  } catch (error) {
    yield put(profileEditFailure(error));
  }
}

export function* watchEditProfile() {
  yield takeLatest(types.EDIT_PROFILE_REQUEST, handleEditProfileAPI);
}
